import {onAuthStateChanged} from 'firebase/auth'
import {auth} from '../components/firebase'
import 'firebase/auth'
// const TOKEN_REFRESH_INTERVAL = 50 * 60 * 1000;
const AUTH_LOCAL_STORAGE_KEY = 'isLoggedIn'

// let isRefreshing = false
// let refreshTokenPromise: Promise<any> | null = null

const CUSTOM_TOKEN = import.meta.env.VITE_CUSTOM_TOKEN
const fetchAuth = (): any | undefined => {
  if (!localStorage) {
    return false
  }

  const lsValue: any | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) {
    return false
  } else {
    return true
  }
}

const setAuth = (auth: any) => {
  if (!localStorage) {
    return
  }

  localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, auth)
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }
  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
    localStorage.removeItem('userId')
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

// no need to check refresh token as now firebase is auto handling it
// const refreshAuthToken = async (api: AxiosInstance): Promise<any | undefined> => {
//   if (!refreshTokenPromise) {
//     isRefreshing = true
//     refreshTokenPromise = new Promise(async (resolve, reject) => {
//       try {
//         const id = localStorage.getItem('userId')
//         if (!id) {
//           window.location.href = '/'
//           removeAuth()
//           reject(new Error('User id not found'))
//         }
//         const response = await api.get(`/users/auth/getToken/${id}`, {
//           headers: {
//             'custom-token': CUSTOM_TOKEN !== undefined ? CUSTOM_TOKEN : '',
//           },
//         })
//         const newAuth = response?.data?.data
//         api.defaults.headers.common['Authorization'] = `Bearer ${newAuth.auth_token}`
//         setAuth({data: newAuth.auth_token})
//         console.log('Token refreshed successfully')

//         isRefreshing = false
//         refreshTokenPromise = null
//         resolve(newAuth)
//       } catch (error: any) {
//         console.error('Token refresh failed', error)
//         if (error.response?.status === 401) {
//           window.location.href = '/'
//           removeAuth()
//         }
//         isRefreshing = false
//         refreshTokenPromise = null
//         reject(error)
//       }
//     })
//   }
//   return refreshTokenPromise
// }

const waitForUser = (): Promise<any> => {
  return new Promise((resolve) => {
    if (auth.currentUser) {
      return resolve(auth.currentUser)
    }
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe()
      resolve(user)
    })
  })
}

const getIdToken: any = async () => {
  let user = auth.currentUser
  if (!user) {
    user = await waitForUser()
  }
  if (user) {
    const token = await user.getIdToken(true)
    return token
  }
}

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    async (config: {headers: {Authorization: string; 'custom-token': string}}) => {
      const token = await getIdToken()
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${token}`,
        'custom-token': CUSTOM_TOKEN ?? '',
      }
      return config
    },
    (err: any) => Promise.reject(err)
  )

  axios.interceptors.response.use(
    (response: any) => {
      return response
    },
    async (error: any) => {
      const status = error.response?.status

      // no need to check refresh token as now firebase is auto handling it
      // const originalRequest = error.config
      // if (status === 403) {
      //   const newAuth = await refreshAuthToken(axios)
      //   if (newAuth?.auth_token) {
      //     originalRequest.headers.Authorization = `Bearer ${newAuth.auth_token}`
      //     return axios(originalRequest) // Retry original request with new token
      //   }
      // }

      if (status === 401 || status === 403) {
        window.location.href = '/'
        removeAuth()
      }
      return Promise.reject(error)
    }
  )
  // setInterval(() => {
  //   refreshAuthToken(axios).catch((error) =>
  //     console.error("Automatic token refresh failed", error)
  //   );
  // }, 60000);
}

export {fetchAuth, setAuth, removeAuth, getIdToken, AUTH_LOCAL_STORAGE_KEY}
